var Cookies = function () { // eslint-disable-line no-unused-vars
    'use strict';

    /* ========================================================================
     *  Private Variables
     * ========================================================================
    */


    /* ========================================================================
     *  Private Methods
     * ========================================================================
    */


    /* ========================================================================
     *  Public Methods
     * ========================================================================
    */

    return {
        /**
         * Get a cookie value by key.
         * @param {string} key
         */
        get: function (key) {
            key += '=';
            const allCookies = document.cookie.split(';');
            for (let i = 0; i < allCookies.length; i++) {
                let current = allCookies[i].trim();
                if (current.indexOf(key) === 0) {
                    return current.substring(key.length, current.length);
                }
            }
            return null;
        },

        /**
         * Set a cookie value
         * @param {string} key
         * @param {any} value This will be converted to a string
         * @param {number} days Days until the cookie should expire. Defaults to 31.
         */
        set: function (key, value, days) {
            let date = new Date();
            days = days || 31;
            date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
            const expires = "; expires=" + date.toUTCString();
            document.cookie = key + "=" + value + expires + "; path=/";
        }
    };
}();